import { isAgentBrandShow as getIsAgentBrandShow, isDealAndProfi, isPublishedUser } from './helpers';
import { EUserTrustLevel } from '../../types/offer';
import * as React from 'react';
import * as PropTypes from 'prop-types';

import { PartnerTooltip } from '../../components/PartnerTooltip';
import { IconBlacklist, IconWhitelist } from './icons';
import { IUserInfoContext, TUserInfoType } from './';
import { HonestWorkVertical } from './HonestWorkVertical';
import * as style from './index.css';

export class UserInfoVertical extends React.Component<{}> {
  public context: IUserInfoContext;

  public static contextTypes = {
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
    user: PropTypes.object,
  };

  public static defaultProps = {
    type: 'vertical' as TUserInfoType,
  };

  public render() {
    const { offer, user, offerHelper } = this.context;
    const { isPro, isByHomeowner } = offer;
    const { tariff, isAgent } = user;

    const userPersonalRating = offerHelper.presenters.getUserPersonalRating();
    const userId = offerHelper.presenters.getCianUserId();
    const agentName = offerHelper.presenters.getAgentName();
    const companyName = offerHelper.presenters.getCompanyName();
    const isFromBuilder = offerHelper.isFromBuilder();
    const isFromSeller = offerHelper.isFromSeller();
    const isRepresentative = !!(offer.businessShoppingCenter && offer.businessShoppingCenter.fromRepresentative);
    const accountType = offerHelper.presenters.getAccountType();
    const isShowLabelOfAccountType = isDealAndProfi(tariff, accountType);
    const userTrustLevel = offerHelper.presenters.getUserTrustLevel();
    const isHonestwork = userTrustLevel === EUserTrustLevel.Involved;
    const isAgentBrandShow = getIsAgentBrandShow(offer, userTrustLevel);
    const isCianPartner = offer.user && offer.user.isCianPartner;
    const isAgentUser = !!isAgent;
    const isPublicUser = isPublishedUser(offer);

    return (
      <div className={style['userInfoContainer']}>
        {isAgentBrandShow && (
          <div className={style['userInfo-name']}>
            <noindex>{agentName || `ID ${userId}`}</noindex>
          </div>
        )}

        {isAgentBrandShow && companyName && (
          <div className={style['userInfo-company']}>
            <noindex>{companyName}</noindex>
          </div>
        )}

        {isFromBuilder && (
          <div
            className={`${style['userInfo-textBadge']} ${style['userInfo-textBadge--green']}`}
            title="Объявления, размещаемые самим застройщиком, либо агентством недвижимости с официальным правом продажи по ценам застройщика" // tslint:disable-line:max-line-length
          >
            Застройщик
          </div>
        )}

        {!isFromBuilder && isFromSeller && (
          <div className={`${style['userInfo-textBadge']} ${style['userInfo-textBadge--green']}`}>
            <span>
              Представитель
              <br />
              застройщика
            </span>
          </div>
        )}

        <div className={`${style['userInfo-badges']}`}>
          {isAgentBrandShow && isHonestwork && <HonestWorkVertical />}

          {isAgentUser && isAgentBrandShow && !isFromBuilder && !isFromSeller && isPro && (
            <div className={style['userInfo-badge']}>
              <div className={`${style['userInfo-textBadge']}`}>PRO</div>
            </div>
          )}

          {isCianPartner && (
            <PartnerTooltip
              master={
                <div className={style['userInfo-badge']}>
                  <div className={`${style['userInfo-textBadge']} ${style['greenLight']}`}>Партнёр</div>
                </div>
              }
            />
          )}

          {isByHomeowner && (
            <div className={style['userInfo-badge']}>
              <div className={`${style['userInfo-textBadge']}`}>Собственник</div>
            </div>
          )}

          {isRepresentative && (
            <div className={style['userInfo-badge']}>
              <div className={`${style['userInfo-textBadge']} ${style['greenLight']}`}>Оф. представитель</div>
            </div>
          )}

          {isPublicUser && isShowLabelOfAccountType && !isRepresentative && (
            <div className={style['userInfo-badge']}>
              <div className={`${style['userInfo-textBadge']} ${style['greenLight']}`}>
                {accountType === 'managementCompany' ? 'Управляющая компания' : 'Отдел аренды'}
              </div>
            </div>
          )}

          {userPersonalRating === 'positive' && (
            <div className={style['userInfo-badge']}>
              <IconWhitelist isActive />
            </div>
          )}

          {userPersonalRating === 'negative' && (
            <div className={style['userInfo-badge']}>
              <IconBlacklist isActive />
            </div>
          )}
        </div>
      </div>
    );
  }
}
